export const normalizeSellingPrice = (value) => {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? Math.round(Math.max(0, parsedValue)) : 0;
};

export const normalizePricingText = (value = "") =>
  String(value || "").trim().toUpperCase().replace(/[^A-Z0-9]+/g, " ");

export const isDiscountEligibleProduct = (source = {}) => {
  const text = typeof source === "string"
    ? normalizePricingText(source)
    : normalizePricingText([
      source.category,
      source.material,
      source.subcategory,
      source.type,
      source.productType,
    ].filter(Boolean).join(" "));

  return /\bBRASS\b/.test(text) || /\bSTEEL\b/.test(text);
};

export const parseDiscountPercent = (value) => {
  if (value === "" || value === null || value === undefined) return null;
  const parsedValue = Number(value);
  if (!Number.isFinite(parsedValue)) return null;
  return Math.min(100, Math.max(0, Math.round(parsedValue)));
};

export const getAutomaticDiscountPercent = (sellingPriceValue, source = {}) => {
  const sellingPrice = normalizeSellingPrice(sellingPriceValue);
  const isTierDiscountProduct = isDiscountEligibleProduct(source);

  if (isTierDiscountProduct) {
    if (sellingPrice <= 1500) return 0;
    if (sellingPrice <= 3000) return 15;
    return 25;
  }

  const explicitDiscount = parseDiscountPercent(source.categoryDiscountPercent ?? source.discountOverride);

  if (explicitDiscount !== null) return explicitDiscount;
  if (source.discountSource === "category") {
    const categoryDiscount = parseDiscountPercent(source.discount);
    if (categoryDiscount !== null) return categoryDiscount;
  }

  return 0;
};

export const roundToPriceEndingInFive = (value) => {
  const roundedValue = Math.round(Math.max(0, Number(value) || 0));

  if (roundedValue === 0) return 0;

  const remainder = roundedValue % 10;
  if (remainder === 5) return roundedValue;
  if (remainder === 0) return roundedValue + 5;
  return roundedValue - remainder + 5;
};

export const calculateAutomaticCustomerPrice = (sellingPriceValue, source = {}) => {
  const sellingPrice = normalizeSellingPrice(sellingPriceValue);
  if (sellingPrice <= 0) return 0;

  const discountPercent = getAutomaticDiscountPercent(sellingPrice, source);
  if (discountPercent === 0) return sellingPrice;

  const discountedPrice = sellingPrice - ((sellingPrice * discountPercent) / 100);
  return roundToPriceEndingInFive(discountedPrice);
};

export const getProductPriceDisplay = (product = {}) => {
  const sellingPrice = normalizeSellingPrice(product?.price);
  const discountPercent = getAutomaticDiscountPercent(sellingPrice, product);
  const hasSellingPrice = sellingPrice > 0;
  const hasDiscount = hasSellingPrice && discountPercent > 0;
  const customerPrice = hasSellingPrice ? calculateAutomaticCustomerPrice(sellingPrice, product) : 0;

  return {
    customerPrice,
    sellingPrice: hasDiscount ? sellingPrice : null,
    hasDiscount,
    discountPercent,
  };
};

export const formatInr = (value, options = {}) => {
  const amount = Number(value);

  if (!Number.isFinite(amount)) {
    return options.fallback || "Rs. 0";
  }

  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: options.maximumFractionDigits ?? 0,
  }).format(amount);
};

